export default {
  licenseRenewal: 'Knockaut Lizenz Erneuerung',
}
